export const messages = {
  smthWentWrong: 'Oops, something went wrong',
  smthWentWrongReload: 'Something went wrong, please reload the page',
  errorInternalServer: 'Oops, something went wrong on our end',
  errorNotFound: 'Oops, we couldn’t find the page you’re looking for',
  errorServiceUnavailable: 'Service currently unavailable. Please try again later',
  errorGatewayTimeout: 'Looks like our server took too long to respond. Please try again later',
  errorUnknown: 'Unknown error',
  error: 'Error'
};
